import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getTestLabels } from '../../utils/getTestLabels.js';
import style from './GridContainer.module.scss.js';

const { componentTestLabel } = getTestLabels('GridContainer');
/**
 *[source code](https://src.private.zooplus.net/projects/FE/repos/ui-components/browse/src/components/GridContainer/GridItem)
 */
const GridItem = forwardRef((props, ref) => {
    const { children, colSpan, colStart, ...otherProps } = props;
    let styles = {};
    let colSpanObject = {};
    let colStartObject = {};
    if (colSpan) {
        colSpanObject = colSpan;
        Object.keys(colSpanObject).forEach((key) => {
            styles = {
                ...styles,
                [`--pp-GridItem-cols${key === 'default' ? '' : `--bp-${key}`}`]: colSpanObject[key],
            };
        });
    }
    if (colStart) {
        colStartObject = colStart;
        Object.keys(colStartObject).forEach((key) => {
            styles = {
                ...styles,
                [`--pp-GridItem-start${key === 'default' ? '' : `--bp-${key}`}`]: colStartObject[key],
            };
        });
    }
    return (jsx("div", { "data-zta": componentTestLabel, ref: ref, ...otherProps, className: style['pp-GridItem'], style: {
            ...styles,
        }, children: children }));
});
GridItem.displayName = 'GridItem';

export { GridItem };
//# sourceMappingURL=GridItem.js.map
